<template lang="pug">
.benchmarks-organization
  h5.benchmarks-heading Past 7 days for your organization

  .org-graph
    .org-graph-items
      //- These items are static, the dynamic bit is the badge + label
      .org-graph-item(
        v-for="level in levels"
        :key="level"
        :class="level"
      )
    .org-graph-label(
      :class="averageRangeClass"
      :style="{ bottom: `${tabData.activity_average}%` }"
    )
      .org-graph-pill.benchmarks-pill(:class="averageRangeClass") {{ tabData.activity_average }}%
      | {{ averageBadgeLabel }}

  p.org-summary.benchmarks-meta {{ summaryMessage }}

  p.benchmarks-meta(v-if="tabData.settings_url")
    span(v-if="!tabData.industry")
      a(:href="tabData.settings_url") Set your industry
      |
      | for more precise averages.

    span(v-else-if="tabData.industry.other")
      a(:href="tabData.settings_url") Update to a more common industry
      |
      | to see better averages and comparisons.

  //- Insights isn't quite ready yet, let's comment for now.
  //- p.benchmarks-meta
  //-   a(:href="insightsUrl") Check out Insights
  //-   |  for more benchmarks and trends
</template>

<script>
import { isNil } from 'lodash-es';
import { mapState } from 'vuex';
import { getAverageRange } from '~/utils/benchmarks';

export default {
  name: 'ActivitiesBenchmarksDialogOrganization',
  props: {
    tabData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      insightsUrl: 'insights_url',
    }),
    levels() {
      return ['high', 'medium', 'low'];
    },
    summaryMessage() {
      const { activity_average: activityAverage, activity_average_industry_diff: averageIndustryDiff } = this.tabData;
      const averagePhrase = `Your average is ${activityAverage}%.`;

      // We can't present much further than this if there's no industry data comparison
      // to show. Rare but possible scenario.
      if (isNil(averageIndustryDiff)) {
        return averagePhrase;
      }

      const compMessage =
        averageIndustryDiff > 0 || averageIndustryDiff < 0
          ? `${Math.abs(averageIndustryDiff)}% ${averageIndustryDiff < 0 ? 'lower' : 'higher'} than`
          : 'equal to';

      return `${averagePhrase} That's ${compMessage} ${this.summarySubject}. ${this.cheersMessage}`;
    },
    summarySubject() {
      const { industry, industry_average_specific: industryAverageSpecific } = this.tabData;

      if (industry && industryAverageSpecific) {
        return `the other organizations in the ${industry.name} industry`;
      }

      return 'the other organizations';
    },
    cheersMessage() {
      const { activity_average: activityAverage, activity_average_industry_diff: averageIndustryDiff } = this.tabData;

      if (averageIndustryDiff > 0 && activityAverage >= 40) {
        return 'Way to go!';
      }

      return '';
    },
    averageBadgeLabel() {
      const { activity_average: activityAverage } = this.tabData;

      if (activityAverage >= 80) {
        return 'Excellent!';
      }

      if (activityAverage >= 60 && activityAverage <= 79) {
        return 'Great';
      }

      if (activityAverage >= 40 && activityAverage <= 59) {
        return 'Good';
      }

      if (activityAverage >= 20 && activityAverage <= 39) {
        return 'OK';
      }

      return 'Poor';
    },
    averageRangeClass() {
      const { activity_average: activityAverage } = this.tabData;

      return getAverageRange(activityAverage);
    },
  },
};
</script>
